/* Mes Petits Repères — scripts communs (léger, sans dépendance)
   - rotation de la barre d'annonce sur mobile
   - indicateur de progression des carrousels horizontaux
   - lecture des vidéos des cartes
   - accordéons « un seul ouvert à la fois »
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)');

  /* Barre d'annonce ------------------------------------------------------ */
  function initAnnouncements(root) {
    (root || document).querySelectorAll('[data-mpr-rotate]').forEach(function (list) {
      if (list.dataset.mprReady) return;
      list.dataset.mprReady = '1';
      var items = Array.prototype.slice.call(list.children);
      if (items.length < 2) return;
      var delay = parseInt(list.dataset.mprRotate, 10) || 5000;
      var index = 0;
      var paused = false;
      list.addEventListener('mouseenter', function () { paused = true; });
      list.addEventListener('mouseleave', function () { paused = false; });
      list.addEventListener('focusin', function () { paused = true; });
      list.addEventListener('focusout', function () { paused = false; });
      if (reduceMotion) return;
      window.setInterval(function () {
        if (paused || desktop.matches || document.hidden) return;
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, delay);
    });
  }

  /* Carrousels horizontaux ---------------------------------------------- */
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-mpr-scroller]').forEach(function (scroller) {
      if (scroller.dataset.mprReady) return;
      scroller.dataset.mprReady = '1';
      var bar = scroller.parentElement.querySelector('.mpr-scroller-bar');
      if (!bar) return;
      var update = function () {
        var max = scroller.scrollWidth - scroller.clientWidth;
        if (max <= 2) {
          bar.hidden = true;
          return;
        }
        bar.hidden = false;
        var ratio = scroller.clientWidth / scroller.scrollWidth;
        var width = Math.max(ratio * 100, 18);
        var progress = scroller.scrollLeft / max;
        bar.style.setProperty('--mpr-progress-w', width + '%');
        bar.style.setProperty('--mpr-progress-x', progress * ((100 - width) / width) * 100 + '%');
      };
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Vidéos des cartes ---------------------------------------------------- */
  function initVideos(root) {
    (root || document).querySelectorAll('[data-mpr-video]').forEach(function (wrapper) {
      if (wrapper.dataset.mprReady) return;
      wrapper.dataset.mprReady = '1';
      var button = wrapper.querySelector('[data-mpr-video-play]');
      var video = wrapper.querySelector('video');
      if (!button || !video) return;
      button.addEventListener('click', function () {
        if (video.paused) {
          video.muted = false;
          video.controls = true;
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
          wrapper.classList.add('is-playing');
          button.setAttribute('aria-pressed', 'true');
        } else {
          video.pause();
          wrapper.classList.remove('is-playing');
          button.setAttribute('aria-pressed', 'false');
        }
      });
      video.addEventListener('pause', function () {
        wrapper.classList.remove('is-playing');
        button.setAttribute('aria-pressed', 'false');
      });
      video.addEventListener('play', function () { wrapper.classList.add('is-playing'); });
    });
  }

  /* Accordéons ----------------------------------------------------------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('[data-mpr-accordion-single]').forEach(function (group) {
      if (group.dataset.mprReady) return;
      group.dataset.mprReady = '1';
      group.addEventListener('toggle', function (event) {
        var opened = event.target;
        if (!opened.open || opened.tagName !== 'DETAILS') return;
        group.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== opened) other.open = false;
        });
      }, true);
    });
  }

  function init(root) {
    initAnnouncements(root);
    initScrollers(root);
    initVideos(root);
    initAccordions(root);
  }

  window.MPR = window.MPR || {};
  window.MPR.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
